module.exports = __webpack_public_path__ + "static/kulkumuodot-c3e9d3f41291ddac7f7a055b3f733736.png";